import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useApp } from "../context/AppContext";
import PrioritiesPanel from "./PrioritiesPanel";

// Entity-scoped "what to work on next" (impact/effort quadrants), shown above the
// entity tabs. Renders nothing when the entity has no scored open work, so
// portfolio-only / idle entities stay clean.
export default function EntityFocus({ entity }) {
  const { t, lang } = useApp();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    let active = true;
    setData(null);
    api.get(`/dashboard/entity-focus?entity_id=${entity.id}`)
      .then(({ data }) => { if (active) setData(data); })
      .catch(() => { if (active) setData({ priorities: {} }); });
    return () => { active = false; };
  }, [entity.id]);

  if (!data) return null;
  const priorities = data.priorities || {};
  const prioTotal = ["quick_win", "major_bet", "fill_in", "thankless"]
    .reduce((n, k) => n + (priorities[k]?.length || 0), 0);
  if (prioTotal === 0) return null;

  return (
    <div data-testid="entity-focus">
      <PrioritiesPanel priorities={priorities} t={t} lang={lang} navigate={navigate}
        className="mb-8" />
    </div>
  );
}
